/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RefundSplitDto } from './RefundSplitDto';
import {
    RefundSplitDtoFromJSON,
    RefundSplitDtoFromJSONTyped,
    RefundSplitDtoToJSON,
    RefundSplitDtoToJSONTyped,
} from './RefundSplitDto';

/**
 * 
 * @export
 * @interface InitiateRefundRequest
 */
export interface InitiateRefundRequest {
    /**
     * 
     * @type {InitiateRefundRequestRefundSplitDistributionTypeEnum}
     * @memberof InitiateRefundRequest
     */
    refundSplitDistributionType: InitiateRefundRequestRefundSplitDistributionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof InitiateRefundRequest
     */
    clientRefundReference?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InitiateRefundRequest
     */
    refundAmount?: string | null;
    /**
     * 
     * @type {Array<RefundSplitDto>}
     * @memberof InitiateRefundRequest
     */
    refundSplits?: Array<RefundSplitDto> | null;
    /**
     * 
     * @type {string}
     * @memberof InitiateRefundRequest
     */
    terminalId?: string | null;
}


/**
 * @export
 */
export const InitiateRefundRequestRefundSplitDistributionTypeEnum = {
    CUSTOM_SPLIT_DISTRIBUTION: 'CUSTOM_SPLIT_DISTRIBUTION',
    FULL_REFUND_ACCORDING_TO_PAYMENT_SPLITS: 'FULL_REFUND_ACCORDING_TO_PAYMENT_SPLITS'
} as const;
export type InitiateRefundRequestRefundSplitDistributionTypeEnum = typeof InitiateRefundRequestRefundSplitDistributionTypeEnum[keyof typeof InitiateRefundRequestRefundSplitDistributionTypeEnum];


/**
 * Check if a given object implements the InitiateRefundRequest interface.
 */
export function instanceOfInitiateRefundRequest(value: object): value is InitiateRefundRequest {
    if (!('refundSplitDistributionType' in value) || value['refundSplitDistributionType'] === undefined) return false;
    return true;
}

export function InitiateRefundRequestFromJSON(json: any): InitiateRefundRequest {
    return InitiateRefundRequestFromJSONTyped(json, false);
}

export function InitiateRefundRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiateRefundRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'refundSplitDistributionType': json['refundSplitDistributionType'],
        'clientRefundReference': json['clientRefundReference'] === undefined ? undefined : json['clientRefundReference'] === null ? null : json['clientRefundReference'],
        'refundAmount': json['refundAmount'] === undefined ? undefined : json['refundAmount'] === null ? null : json['refundAmount'],
        'refundSplits': json['refundSplits'] === undefined ? undefined : json['refundSplits'] === null ? null : ((json['refundSplits'] as Array<any>).map(RefundSplitDtoFromJSON)),
        'terminalId': json['terminalId'] === undefined ? undefined : json['terminalId'] === null ? null : json['terminalId'],
    };
}

export function InitiateRefundRequestToJSON(json: any): InitiateRefundRequest {
    return InitiateRefundRequestToJSONTyped(json, false);
}

export function InitiateRefundRequestToJSONTyped(value?: InitiateRefundRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'refundSplitDistributionType': value['refundSplitDistributionType'],
        'clientRefundReference': value['clientRefundReference'],
        'refundAmount': value['refundAmount'],
        'refundSplits': value['refundSplits'] == null ? undefined : ((value['refundSplits'] as Array<any>).map(RefundSplitDtoToJSON)),
        'terminalId': value['terminalId'],
    };
}

